import { defineComponent } from "vue";
export default defineComponent({
  name: "MainFoot",
  setup: function setup() {
    return {};
  }
});